import { Component, ElementRef, EventEmitter, Input, Output, ViewChild } from '@angular/core';
import { ExcelValidationService } from '../../../verification/services/excel-validation.service';
import { ProductMasterConstants, StoreMasterConstants } from '../../../Common/Constants/data';

@Component({
  selector: 'app-master-file-upload',
  templateUrl: './master-file-upload.component.html',
  styleUrl: './master-file-upload.component.css'
})
export class MasterFileUploadComponent {

  @ViewChild('fileInput') fileInput!: ElementRef<HTMLInputElement>;
  @Input() allowedFileTypes: string = '';
  @Input() srcFileComponent: string = '';
  @Output() productfileChanged = new EventEmitter<Array<{ name: string, base64: string }>>();

  files: Array<{ name: string, base64: string }> = [];
  fileInputId: string = 'file-input';

  constructor(private excelValidationService: ExcelValidationService) { }

  triggerFileInput(): void {
    if (this.fileInput) {
      this.fileInput.nativeElement.click();
    }
  }

  onFilesSelected(event: any) {
    const selectedFiles = event.target.files;
    this.files = [];

    let sheetName: string;
    let requiredColumns: string[];

    if (this.srcFileComponent === 'products') {
      ({ sheetName, requiredColumns } = ProductMasterConstants.getProductUploadConstants());
    } else if (this.srcFileComponent === 'stores') {
      ({ sheetName, requiredColumns } = StoreMasterConstants.getStoreUploadConstants());
    } else {
      throw new Error(`Unknown srcFileComponent: ${this.srcFileComponent}`);
    }

    const file = selectedFiles[0];
    if (file) {
      const fileSizeInMB = file.size / (1024 * 1024);
      //Max File Size - 100 MB
      if (fileSizeInMB > 100) {
        this.files = [{ name: 'Invalid', base64: '' }];
        this.productfileChanged.emit(this.files);
        this.resetFileInput();
        return;
      }

      this.excelValidationService.validateFile(file, sheetName, requiredColumns)
        .then(isValid => {
          if (isValid) {
            this.convertToBase64(file).then(base64 => {
              this.files = [{ name: file.name, base64: base64 }];
              this.productfileChanged.emit(this.files);
              // this.resetFileInput();
            });
          } else {
            this.files = [{ name: 'Invalid', base64: '' }];
            this.productfileChanged.emit(this.files);
            this.resetFileInput();
          }
        })
        .catch(error => {
          console.error('Error validating file', error);
        });

    }
  }

  convertToBase64(file: File): Promise<string> {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.onloadend = () => {
        const base64 = (reader.result as string).split(',')[1]; // Remove data URL prefix
        resolve(base64);
      };
      reader.onerror = () => reject('Error reading file');
      reader.readAsDataURL(file);
    });
  }

  public resetFileInput() {
    const fileInput = this.fileInput.nativeElement as HTMLInputElement;
    fileInput.value = '';
  }

}
